import { QueryFactory } from "../../../../Common";
export const QGetLeagues = QueryFactory("GetLeagues");
//# sourceMappingURL=QGetLeagues.js.map